import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

// Custom error route component
const ErrorRoute = ({ error, resetError }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      textAlign="center"
      p={3}
    >
      <WarningIcon sx={{ fontSize: 64, color: 'warning.main', mb: 2 }} />
      <Typography variant="h4" gutterBottom>
        Something went wrong
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={3}>
        {error?.message || 'An unexpected error occurred'}
      </Typography>
      {resetError && (
        <Button variant="contained" onClick={resetError}>
          Try Again
        </Button>
      )}
    </Box>
  );
};

export default ErrorRoute;
